import React from 'react';
import './index.css'
import MyForm from './UI/form/MyForm';

const Header = function () {
    return (  
        <div className='header'>
            <MyForm></MyForm>
        </div>
    );
}

export default Header;